export default function seriesAddPrevLatestToName(dataSeries) {
    //Check to see if any of the data series is a compare series. If there is compare data then add the prefix.
    const dataWithCompare = dataSeries.find((series) => {
        if (series.isCompareSeries) {
            return true;
        }
        else {
            return false;
        }
    });
    if (dataWithCompare) {
        // Add "Latest " in front of the series name for normal series. Add "Previous " in front of the series name for compare series.
        dataSeries.forEach((series) => {
            if (series.isCompareSeries) {
                if (!series.name.startsWith("Previous")) {
                    series.name = "Previous " + series.name;
                }
            }
            else {
                if (!series.name.startsWith("Latest")) {
                    series.name = "Latest " + series.name;
                }
            }
        });
    }
    return dataSeries;
}
